export default [
  {
    name: 'BetNSettle Win',
    functionName: 'betNSettleWin',
  },
  {
    name: 'BetNSettle Lose',
    functionName: 'betNSettleLose',
  },
  {
    name: 'BetNSettle Win 5 times',
    functionName: 'betNSettleWin5Times',
  },
  {
    name: '(Network) BetNSettle Win 5 times',
    functionName: 'asyncBetNSettleWin5Times',
  },
  {
    name: 'BetNSettle Win > CancelBetNSettle',
    functionName: 'betNSettleWin_cancelBetNSettle',
  },
  {
    name: 'BetNSettle Lose > CancelBetNSettle',
    functionName: 'betNSettleLose_cancelBetNSettle',
  },
  {
    name: 'BetNSettle Win > CancelBetNSettle 5 times',
    functionName: 'betNSettleWin_cancelBetNSettle5Times',
  },
  {
    name: 'CancelBetNSettle only',
    functionName: 'cancelBetNSettleOnly',
  },
  {
    name: 'CancelBetNSettle > BetNSettle Win',
    functionName: 'cancelBetNSettle_betNSettleWin',
  },
  {
    name: 'Multi Bets - Place 10 BetNSettle > CancelBetNSettle',
    functionName: 'betNSettleWin10Times_cancelBetNSettle_sameRound',
  },
  {
    name: 'Negative Balance - BetNSettle Win > CancelBetNSettle',
    functionName: 'negativeBalance_betNSettleWin_cancelBetNSettle',
  },
  {
    name: 'Positive Balance - Sufficient - BetNSettle Win',
    functionName: 'positiveBalance_sufficient_betNSettleWin',
  },
  {
    name: 'Positive Balance - Insufficient - BetNSettle Win',
    functionName: 'positiveBalance_insufficient_betNSettleWin',
  },
  {
    name: 'Positive Balance - Insufficient - BetNSettle Lose',
    functionName: 'positiveBalance_insufficient_betNSettleLose',
  },
  {
    name: 'Zero Balance - BetNSettle Win',
    functionName: 'zeroBalance_betNSettleWin',
  },
  {
    name: 'Zero Balance - BetNSettle Lose',
    functionName: 'zeroBalance_betNSettleLose',
  },
  {
    name: 'Negative Balance - BetNSettle Win',
    functionName: 'negativeBalance_betNSettleWin',
  },
  {
    name: 'Negative Balance - BetNSettle Lose',
    functionName: 'negativeBalance_betNSettleLose',
  },
]
